import React from "react";
import { Dialog, Slide, Button, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

export default (props) => {
    const { data } = props;
    console.log(data);
    return (
        <Dialog
            fullScreen
            open={props.projectDescShow}
            onClose={props.closeModal}
            TransitionComponent={Transition}
        >
            <AppBar className={props.classes.appBar}>
                <Toolbar>
                    <IconButton color="inherit" onClick={props.closeModal} aria-label="Close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="title" color="inherit" className={props.classes.flex}>
                        {
                            props.data ?
                                props.data.name.slice(0,1).toUpperCase()+props.data.name.slice(1)
                                : <span></span>
                        }
                    </Typography>
                    <Button className={props.classes.button} onClick={props.closeModal}>Back</Button>
                </Toolbar>
            </AppBar>
            {
                data !== undefined &&
                <div style={styles.mainInfoContainer}>
                    <p style={styles.mainInfoHeading}>Name: <span style={styles.mainInfoSpan}>{props.data.name.slice(0,1).toUpperCase()+props.data.name.slice(1)}</span></p>
                    <p style={styles.mainInfoHeading}>Description: <span style={styles.mainInfoSpan}>{props.data.description.slice(0,1).toUpperCase()+props.data.description.slice(1)}</span></p>
                    <p style={styles.mainInfoHeading}>Project Images: </p>
                    {
                        data.images.map((img, i) => <img src={img} alt="Project Picture" style={styles.projectImg} onClick={_ => props.showLightBox(i)} />)
                    }
                </div>
            }
        </Dialog>
    );
};

const styles = {
    mainInfoContainer: {
        fontFamily: "Roboto, sans-serif",
        padding: '100px 20px'
    },
    mainInfoHeading: {
        fontWeight: 'bold',
        fontSize: 18
    },
    mainInfoSpan: {
        fontWeight: 500,
        fontSize: 16
    },
    projectImg: {
        height: 100,
        width: 100,
        borderRadius: 10,
        marginRight: 10,
        cursor: 'pointer'
    }
};


// WEBPACK FOOTER //
// ./src/Components/projectDetailsDialog.jsx